import { Request } from '@/Types';

export enum NotifiableType {
    STATION = 'station',
    DEVICE = 'device',
}

export type StationsQuery = Request.Pagination & {
    companies_ids?: string;
    store_groups_ids?: string;
    stores_ids?: string;
};

export type NotificationsQuery = Request.Pagination & {
    'notifiable[type]': NotifiableType;
    'notifiable[id]': number;
    is_read?: string;
    order_by?: string;
};

export interface ReadNotificationsRequest {
    notifiable: {
        type: NotifiableType;
        id: number;
    };
    notifications_ids: number[];
}
